// ============================================================================
// EmployeeGrid — STUB (SL-B) — decoupage SL-B/SL-C tranche (David 2026-07-17)
// ============================================================================
// DirectorGridBoard IMPORTE ce composant : sans lui, SL-B ne compilerait pas.
// Decision de decoupage (PLAN-SOUS-LOTS §SL-B/SL-C) : SL-B livre un STUB minimal
// qui EXPOSE la signature de props EXACTE du PoC (509 L, employee-grid.tsx @ SHA
// 7e40e4a) — memes noms, memes types — et rend un EmptyState. Les callbacks sont
// acceptes mais la grille n'est PAS dessinee ici. Le test M-655 vit dans le BOARD
// (isMoved/handleCellClick/moveLineToClass), pas dans la grille : le stub suffit a
// rendre le board testable et compilable.
//
// SL-C remplace ce stub par le vrai composant 509 L (vue employe : barme par
// classe, marqueurs par periode, menu « ... », rangee « + Ajouter »). Zero dette :
// le stub disparait, la signature reste identique => le board ne change pas.
//
// Regle #28 : tokens dark-aware, zero CSS en dur. Regle #4 : zero emoji.

import { EmptyState } from '@gs/ui';
import { LayoutGrid } from 'lucide-react';
import type { EmployeeGridLine } from '../../lib/salary/positions';
import type { SalaryClass } from '../../lib/types/firestore';
import { useTranslation } from '../../i18n';

/**
 * Props VERBATIM du PoC `EmployeeGrid` (employee-grid.tsx:43-69). Toute la surface
 * V2 est optionnelle — le contrat que SL-C devra honorer a l'identique. Le stub
 * ignore les callbacks (aucune cellule cliquable rendue) mais garde la signature
 * pour figer le contrat SL-B ↔ SL-C.
 */
export interface EmployeeGridProps {
  classes: SalaryClass[];
  linesByClass: Record<string, EmployeeGridLine[]>;
  currentYear: number;
  interactive?: boolean;
  onCellClick?: (line: EmployeeGridLine, classId: string, echelon: number) => void;
  onBackfillRequest?: (line: EmployeeGridLine) => void;
  onAddVirtual?: (classId: string, echelon: number, name: string) => void;
  onMoveToClass?: (line: EmployeeGridLine, targetClassId: string) => void;
  onRemoveScenario?: (line: EmployeeGridLine) => void;
  onRenameVirtual?: (lineId: string, name: string) => void;
  // Impact annuel des periodes d'heures speciales par email ($). Negatif = 0 h.
  specialHoursByEmail?: Record<string, number>;
}

export function EmployeeGrid(_props: EmployeeGridProps) {
  const { t } = useTranslation();
  return (
    <EmptyState
      icon={<LayoutGrid size={40} aria-hidden="true" />}
      title={t('gest:planification.gridStub.title')}
      description={t('gest:planification.gridStub.description')}
    />
  );
}
